import { Link } from "react-router-dom";
import { zones } from "@/mocks/zones";
import { siteMeta } from "@/mocks/siteMeta";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const zoneLinks = zones.slice(0, 5);

  return (
    <footer className="bg-secondary-950 text-secondary-50 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-md bg-primary-600 text-background-50 flex items-center justify-center">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl tracking-wide">爆料91</span>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-secondary-200 max-w-md">
              {siteMeta.description}
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm text-secondary-200">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                {siteMeta.email}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-calendar-line text-accent-400"></i>
                内容整理自 {siteMeta.foundedYear} 年起
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-base font-semibold text-secondary-50">专区导航</h4>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              {zoneLinks.map((zone) => (
                <li key={zone.id}>
                  <Link
                    to={`/zone/${zone.id}`}
                    className="text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {zone.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/zones"
                  className="text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  查看全部专区
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-base font-semibold text-secondary-50">内容帮助</h4>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              <li>
                <Link to="/ranking" className="text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer">
                  热榜速览
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer">
                  内容原则
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-base font-semibold text-secondary-50">合作联系</h4>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              <li className="text-secondary-200">内容纠错</li>
              <li className="text-secondary-200">线索建议</li>
              <li className="text-secondary-200">栏目共建</li>
            </ul>
            <p className="mt-5 text-sm text-accent-300 break-all">{siteMeta.cooperationEmail}</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© {year} 爆料91 · 内容聚合整理，所涉作品与人物均为设定内容。</p>
          <p className="flex items-center gap-4">
            <span>本站内容仅供阅读参考</span>
          </p>
        </div>
      </div>
    </footer>
  );
}